export default "__VITE_ASSET__DPaIS$NP__"